// extracted by mini-css-extract-plugin
export default {"sortUpFilled":"SortingIcon-Lincoln_sortUpFilled__iu3R0","sortDown":"SortingIcon-Lincoln_sortDown__VBUPg","sortDownFilled":"SortingIcon-Lincoln_sortDownFilled__A+m+M"};